import { Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import { paloSortedParams } from '@synergy/components-palo';
import { useEffect } from 'react';

import { DashboardOverviewDemands } from './pages/dashboard-overview-demands';
import { DashboardOverviewInquiries } from './pages/dashboard-overview-inquiries';
import { DashboardOverviewInvoices } from './pages/dashboard-overview-invoices';
import { DashboardOverviewPurchaseOrders } from './pages/dashboard-overview-purchase-orders';
import { DashboardOverviewSalesOrders } from './pages/dashboard-overview-sales-orders';
import { DashboardTabs } from '../model/dashboard-tabs';
import { fetchDashboardSearch } from '../store/dashboard-actions';
import { useThunkDispatch } from '../../../store/use-thunk-dispatch';

export const DashboardOverviewOutlet = () => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const dispatch = useThunkDispatch();

    // The tab in the address decides which order is asked for: the cockpit
    // sent none at all, and the engine then answered in the order it happened
    // to hold — an inquiry from 2019 on top (#2234).
    const listKey = location.pathname.split('/').pop() ?? '';
    const params = paloSortedParams(searchParams, listKey);
    const query = params.toString();

    useEffect(() => {
        dispatch(fetchDashboardSearch(new URLSearchParams(query)));
    }, [dispatch, query]);

    return (
        <Routes>
            <Route path={DashboardTabs.SalesOrders} element={<DashboardOverviewSalesOrders />} />
            <Route path={DashboardTabs.Inquiries} element={<DashboardOverviewInquiries />} />
            <Route path={DashboardTabs.PurchaseOrders} element={<DashboardOverviewPurchaseOrders />} />
            <Route path={DashboardTabs.Demands} element={<DashboardOverviewDemands />} />
            <Route path={DashboardTabs.Invoices} element={<DashboardOverviewInvoices />} />
        </Routes>
    );
};
